import { callNative } from '@deliveryteam-spa-orders-vue/native';
import type { LocationPermissionSnapshot } from '@lib/deliveryteamCourierWebviewBridge';
import { ref } from 'vue';
import { currentUserLat, currentUserLng, currentUserHeading } from './UserCurrentLocation';

export const foregroundLocationPermission = ref<LocationPermissionSnapshot | null>(null);
export const backgroundLocationPermission = ref<LocationPermissionSnapshot | null>(null);

const getForegroundLocationPermission = async (): Promise<LocationPermissionSnapshot> => {
    const permission = await callNative('getForegroundPermissionsAsync', undefined);
    foregroundLocationPermission.value = permission;
    return permission;
};

const getBackgroundLocationPermission = async (): Promise<LocationPermissionSnapshot> => {
    const permission = await callNative('getBackgroundPermissionsAsync', undefined);
    backgroundLocationPermission.value = permission;
    return permission;
};

export const requestForegroundLocationPermission = async (): Promise<LocationPermissionSnapshot> => {
    const permission = await callNative('requestForegroundPermissionsAsync', undefined);
    foregroundLocationPermission.value = permission;
    await checkCurrentPosition();
    return permission;
};

export const requestBackgroundLocationPermission = async (): Promise<LocationPermissionSnapshot> => {
    const permission = await callNative('requestBackgroundPermissionsAsync', undefined);
    backgroundLocationPermission.value = permission;
    await checkCurrentPosition();
    return permission;
};

const checkCurrentPosition = async () => {
    if (foregroundLocationPermission.value?.granted || backgroundLocationPermission.value?.granted) {
        const position = await callNative('getCurrentPositionAsync', {
            accuracy: 1,
        });
        currentUserLat.value = position.coords.latitude;
        currentUserLng.value = position.coords.longitude;
        currentUserHeading.value = position.coords.heading;
    }
}

setTimeout(async () => {
    await getForegroundLocationPermission();
    await getBackgroundLocationPermission();
    await checkCurrentPosition();
}, 1000);